<template>
  <div ref="theDom" class="pro-list-item" :title="data.projectName">
    <el-image
      class="pro-list-item-bg"
      lazy
      :src="
        show
          ? data.bgUrl || 'http://cdn.yxvzb.com/WEB/images/saasdefault.png'
          : ''
      "
      alt="."
    ></el-image>
    <!--    <template v-if="show">-->
    <template v-if="true">
      <el-checkbox
        @change="
          () => {
            $emit('choose', data.id);
          }
        "
        :checked="isChoosed"
        :value="isChoosed"
        class="pro-list-item-checkbox"
        v-if="canChoose(data)"
      ></el-checkbox>
      <div class="pro-list-item-mask">
        <el-button
          size="mini"
          type="primary"
          plain
          @click="$emit('jump', data)"
        >
          进入项目
        </el-button>
        <!--        <el-button-->
        <!--          size="mini"-->
        <!--          type="primary"-->
        <!--          plain-->
        <!--          @click="$emit('jumpOrder', data)"-->
        <!--        >-->
        <!--          进入订单-->
        <!--        </el-button>-->
        <el-button
          size="mini"
          type="primary"
          plain
          v-if="isMaster"
          @click="$emit('powerMgmt', data)"
        >
          权限配置
        </el-button>
      </div>
      <!--   分配狀態 start   -->

      <!-- 审核阶段 => 3 审核状态 => 3 任务状态 => 1 -->
      <div
        v-if="
          data.taskStatus == 1 &&
            data.projectStatus == 3 &&
            data.auditStatus == 3
        "
        class="pro-list-item-status pro-list-item-status--success"
      >
        已分配
      </div>
      <template v-else>
        <!-- 
        projectStatus //项目状态  0 乙方待编辑  1  乙方编辑完成   2 甲方待确认   3 甲方编辑完成(甲方已确认)
        auditStatus //审核状态  0 未提交审核  1 审核中  2 审核未通过  3  审核通过
      -->
        <div
          v-if="
            data.projectStatus != 3 ||
              (data.projectStatus == 3 && data.auditStatus == 2)
          "
          class="pro-list-item-status pro-list-item-status--danger"
        >
          待确认
        </div>
        <div v-else class="pro-list-item-status pro-list-item-status--success">
          已确认
        </div>
      </template>
      <!--   分配狀態 ended-->
      <div class="pro-list-item-context">
        <h1 class="fz26 fw600 ellipsis pro-list-item-context-title">
          {{ data.projectName }}
        </h1>
        <p class="fz16 ellipsis" v-if="data.enterpriseName">
          <span class="color-sub">企业名称：</span>
          <span class="fw400">{{ data.enterpriseName }}</span>
        </p>
        <p class="fz16 ellipsis">
          <span class="color-sub">服务类型：</span>
          <span class="fw400">{{ data.projectType | transType(data) }}</span>
        </p>
        <p class="fz16 ellipsis">
          <span class="color-sub">执行日期：</span>
          <span class="fw400">{{ data.projectDt }}</span>
        </p>
        <p class="fz16 ellipsis">
          <span class="color-sub">项目编码：</span>
          <span class="fw400">{{ data.projectNo }}</span>
        </p>
      </div>
    </template>
  </div>
</template>

<script>
import { projectAllList } from '@/config/staticData';
import { mapGetters } from 'vuex';
import { canChoose } from '../tools/index';

function getTop(e, wrap) {
  let T = e.offsetTop;
  while ((e = e.offsetParent) && e !== wrap) {
    T += e.offsetTop;
  }
  return T;
}

export default {
  name: 'project-list-item',
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    offsetY: {
      type: Number,
      default: () => 0
    },
    container: {
      type: HTMLDivElement
    },
    isChoosed: {
      type: Boolean
    }
  },
  data() {
    return {
      canChoose,
      show: true,
      ViewH: 0,
      offsetTop: null
    };
  },
  computed: {
    ...mapGetters(['isMaster'])
  },
  filters: {
    transType(v, item) {
      //cope 的代码 ，具体干啥我也不清楚
      return item.projectType == 20
        ? item.serviceSubitem
        : projectAllList[v - 1].name;
    }
  },
  methods: {
    setVisible(type) {
      this.show = true;
      return;
      let theDom = this.$refs.theDom;
      let view = this.container;
      if (!this.offsetTop || type === 'resize') {
        this.offsetTop = getTop(theDom, view);
      }
      this.show =
        this.offsetTop < view.clientHeight + this.offsetY + 800 &&
        this.offsetY < this.offsetTop + theDom.clientHeight;
    }
  },
  mounted() {
    // this.setVisible();
  }
};
</script>

<style scoped lang="scss">
@import '~@/styles/theme.scss';

.pro-list-item {
  width: 24%;
  float: left;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  background: #fff;
  height: calc(210px + 3vw);

  &:not(:nth-child(4n)) {
    margin-right: 1.3%;
    margin-bottom: 16px;
  }

  box-shadow: 0 6px 10px 0 rgba(95, 101, 105, 0.15);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  &-bg {
    position: absolute;
    top: 0;
    right: 0;
    background: #ebeef5;
    @media screen and (max-width: 1200px) {
      width: 276px;
      height: 80px;
    }
    box-sizing: inherit;
  }
  &-checkbox {
    position: absolute;
    right: 10px;
    top: 5px;
  }
  &-mask {
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: none;
    opacity: 0;
  }

  &-context {
    padding: 8px;
    text-align: left;

    &-title {
      color: $--color-primary;
      padding: 5px 0;
    }
  }

  &-status {
    width: 88px;
    height: 30px;
    border-radius: 15px;
    color: #fff;
    text-align: center;
    font-weight: 400;
    font-size: 16px;
    line-height: 30px;
    position: absolute;
    top: 20px;
    right: 20px;

    &--success {
      background: $--color-success;
    }

    &--danger {
      background: $--color-danger;
    }
  }

  transition: all 0.3s;

  &:hover {
    //transform: scale(1.03);
    box-shadow: 0px 0px 2px 2px #0084ff;

    //border: 2px solid #46a6ff;
    .pro-list-item-mask {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      opacity: 1;
    }
  }
}

.el-button + .el-button {
  margin-left: 0;
  margin-top: 5px;
}
</style>
